const roles = {
  superAdmin: 'superadmin',
  orgAdmin: 'organizationadmin',
  orgEmployee: 'organizationemployee',
  memberCare: 'membercare',
  peerSupport: 'peersupport',
}

export default roles;